import axios from "axios";
import { makeAutoObservable } from "mobx";
export class SuccessModel{
    Success: boolean;
    Description: string;
}
class LoadStore {
    counter: number = 0;
    setStatusTimeout = null;
    isLoading: boolean = false;
    incrementCounter = () => {
        this.counter++;
        this.setIsLoading();
    }
    decrementCounter = () => {
        this.counter--;
        this.setIsLoading();
    }
    setIsLoading = () => {
        this.isLoading = this.counter > 0;
    }
    send = () => {
        this.incrementCounter();
        //if (this.counter > 0) {
        //    this.setStatus("Обмен с сервером", true);
        //    this.counter = 1;
        //}
    }
    complete = () => {
        this.decrementCounter()
        //if (this.counter <= 0) {
        //    this.setStatus("Тайм-аут обмена", false);
        //    this.counter = 0;
        //}
    }
    error = () => {
        this.counter--;
        //if (this.counter <= 0) {
        //    this.setStatus("Тайм-аут обмена", false);
        //    this.counter = 0;
        //}
    }
    constructor() {
        makeAutoObservable(this);
    }
}
const loadStore = new LoadStore();
export const client = axios.create();
client.interceptors.request.use(function (config) {
    loadStore.send();
    return config;
}, function (error) {
    error();
    return Promise.reject(error);
});

// Добавляем перехват ответов
client.interceptors.response.use(function (response) {
    loadStore.complete();
    return response;
}, function (error) {
    loadStore.error();
    return Promise.reject(error);
});
export default loadStore;